import React from "react";
import {Route, Routes, Navigate} from 'react-router-dom'
import{Login,Register} from '../views'

const AuthRoutes = () => {
    return (
        <Routes>
            <Route path="getCompanies" element={<Login />} />
            <Route path="/" element={<Navigate to="/getCompanies" replace/>} />
            <Route path="*" element={<Navigate to="/getCompanies" />} />
        </Routes>
    )
}

export default AuthRoutes